var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBatteryIconDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 65,
    viewBox: "0 0 38 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1408 3.37143e-06C11.484 3.37143e-06 10.1408 1.34315 10.1408 3L10.1408 4.50704L8 4.50704C3.58172 4.50704 0 8.08876 0 12.507L0 56.7887C0 61.207 3.58172 64.7887 8 64.7887L29.1831 64.7887C33.6014 64.7887 37.1831 61.207 37.1831 56.7887L37.1831 12.507C37.1831 8.08876 33.6014 4.50704 29.1831 4.50704L27.0423 4.50704V3C27.0423 1.34315 25.6991 3.37143e-06 24.0423 3.37143e-06L13.1408 3.37143e-06Z",
    fill: "#1A2128"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryIconDark);
export default __webpack_public_path__ + "static/media/battery-icon-dark.72f9c341cc816b5b6c56bdb584748f94.svg";
export { ForwardRef as ReactComponent };